@if (!isSidebar) {
	<div class="d-flex align-items-center gap-1">
		<button type="button" vbBtnWhite [disabled]="isAddNewDisabled()" (click)="onAddNewClick()">
			{{ 'Event_Embed_Content_AddNew' | translate }}
		</button>
		@if (contentLinks?.length >= MAX_EMBEDDED_LINKS) {
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'MaximumAmountReached' | translate">
			</vb-ui-tooltip>
		}
	</div>
}
<div display="flex" layout="column" class="margin-top-20">
	<div ngForm="form">
		@for (link of contentLinks; track $index; let index = $index) {
			<embedded-content-entry [name]="'link' + index" [(ngModel)]="contentLinks[index]" [showToggleBtn]="false" [showPreviewBtn]="true" [showEditDeleteBtns]="!isSidebar && !isAddingNewLink" (editEntry)="onEditEntry(index)" (deleteEntry)="onDeleteEntry(index)">
			</embedded-content-entry>
		}

		@if (isAddingNewLink) {
			<embedded-content-add-form [name]="'newLink'" [(ngModel)]="newLink" [webcastId]="webcastId" [isDuplicateName]="isDuplicateNameForForm" (saveEntry)="onSaveEntry($event)" (cancel)="onCancelAddEntry()">
			</embedded-content-add-form>
		}
	</div>
</div>
